import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
/*App imports*/
import { HelpersService, TiposCreditos } from '../../../services/tools/helpers.service';
import { CreditosService } from "../../../services/creditos.service";
import { CarburacionesService } from "../../../services/creditos/carburaciones.service";
import { EstacionariosService } from "../../../services/creditos/estacionarios.service";
import { ComercializacionService } from "../../../services/creditos/comercializacion.service";

@Component({
  selector: 'header-amortizacion',
  templateUrl: './header-amortizacion.component.html'
})

export class HeaderAmortizacionComponent implements OnInit {
    @Input() public idCreditos: number = null;
    
    public carburacion: any = null;
    
    public credito: any = { cliente : {}, prestamo : {}, sucursal : {} };
    public tituloHeader: string = null;
    public estacionario: any = null;
    //Distribución
    public creditoDistribucion: any = null;
    public errors: any = {};

    constructor(
      private helperService: HelpersService,
      private creditosService : CreditosService,
      private router: Router,
      private location : Location,
      private carburacionesService : CarburacionesService,
      private estacionariosService : EstacionariosService,
      private mesesService: ComercializacionService
    ){
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {

      if (changes.idCreditos && this.idCreditos) {
        this.getCredito(this.idCreditos);    
      }
    }

    private getCredito(idCreditos : number){
        //TODO: Manejar cuando el id no retorna un crédito valido
        this.creditosService.get(idCreditos).subscribe(
            (response)=>
            {
              const credito = response.json().content;
              this.credito = credito;

              switch(credito.idTipos_Creditos){
                case TiposCreditos.Carburacion:
                  this.getCreditoCarburacion(idCreditos);
                  break;
                case TiposCreditos.Estacionario:
                  this.getCreditoEstacionario(idCreditos);
                  break;
                case TiposCreditos.MesesSinIntereses:
                  this.getCreditoMesesSinIntereses(idCreditos);
                  break;

              }
              this.setupCreditoLabels(credito);
              this.setupPrestamoLabels(credito.prestamo);
            
            }, error =>
            {
              // se resuelve error 403 y 500
              this.helperService.httpGlobalError(error);

              if(error.status == 400) {
                this.helperService.setBackendErrors(error.json().content, this.errors);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
              }
            }
        );
    }

    private getCreditoCarburacion(idCreditos : number){
      this.carburacionesService.get(idCreditos).subscribe(
          (response)=>
          {
            const result = response.json().content;
            this.setCreditoDistribucion(result.carburacion);

          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status === 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
      );
    }

    private getCreditoMesesSinIntereses(idCreditos : number){
      this.mesesService.get(idCreditos).subscribe(
          (response)=>
          {
            const result = response.json().content;
            this.setCreditoDistribucion(result.meses);

          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status === 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
      );
    }

    private getCreditoEstacionario(idCreditos : number){
      this.estacionariosService.get(idCreditos).subscribe(
          (response)=>
          {
            const result = response.json().content;
            this.estacionario = result.estacionario;

          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status === 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
      );
    }

    public goBack(){
      if(this.credito.statusCredito == 0){
        //Signigica que el crédito esta en modo borrador por lo tanto hay que pasarle al simulador el Id de este crédtio
        let urlToNavigate = ''; 
        switch(this.credito.idTipos_Creditos){
          case TiposCreditos.Hipotecario:
            urlToNavigate = '/creditos/hipotecario/simulacion/';
            break;
          case TiposCreditos.Automotriz:
            urlToNavigate = '/creditos/automotriz/simulador/';
            break;
          case TiposCreditos.Prendario:
            urlToNavigate = '/creditos/prendario/simulador/';
            break;
          case TiposCreditos.Verde:
            urlToNavigate = '/creditos/verde/simulador/';
            break;
          case TiposCreditos.Personal:
            urlToNavigate = '/creditos/personal/simulador/';
            break;
          case TiposCreditos.Nomina:
              urlToNavigate = '/creditos/nomina/simulador/';
              break;
          case TiposCreditos.Carburacion:
            urlToNavigate = '/creditos/carburacion/simulador/';
            break;
          case TiposCreditos.Estacionario:
              urlToNavigate = '/creditos/estacionario/simulador/';
              break;
          case TiposCreditos.MesesSinIntereses:
            urlToNavigate = '/creditos/comercializacion/simulador/';
            break;
        }
        this.router.navigate([urlToNavigate, this.credito.id]);
      }else{
        //En los otros casos el history back funciona bien
        this.location.back();
      }
    }

    private setupCreditoLabels(credito : any){
        let headerTitle = null;
        console.log(credito);

        switch(credito.idTipos_Creditos){
            case TiposCreditos.Hipotecario:
              headerTitle = 'TABLA DE AMORTIZACIÓN CRÉDITO HIPOTECARIO';
              break;
            case TiposCreditos.Automotriz:
              headerTitle = 'TABLA DE AMORTIZACIÓN CRÉDITO AUTOMOTRIZ';
              break;
            case TiposCreditos.Prendario:
              headerTitle = 'TABLA DE AMORTIZACIÓN CRÉDITO PRENDARIO';
              break;
            case TiposCreditos.Verde:
              headerTitle = 'TABLA DE AMORTIZACIÓN CRÉDITO VERDE';
              break;
            case TiposCreditos.Personal:
              headerTitle = 'TABLA DE AMORTIZACIÓN CRÉDITO PERSONAL';
              break;
            case TiposCreditos.Nomina:
              headerTitle = 'TABLA DE AMORTIZACIÓN CRÉDITO NOMINA';
              break;
            case TiposCreditos.Carburacion:
              headerTitle = 'TABLA DE AMORTIZACIÓN CREDIGAS CARBURACIÓN';
              break;
            case TiposCreditos.Estacionario:
              headerTitle = 'TABLA DE AMORTIZACIÓN CREDIGAS ESTACIONARIO';
              break;
            case TiposCreditos.MesesSinIntereses:
              headerTitle = 'TABLA DE AMORTIZACIÓN CRÉDITO COMERCIALIZACIÓN';
              break;
            case TiposCreditos.PlusPension:
              headerTitle = 'TABLA DE AMORTIZACIÓN CRÉDITO Maxi Pensión';
              break;
        }

        this.tituloHeader = headerTitle;
    }

    private setupPrestamoLabels(prestamo){
      let periodicidad_label = '';
      switch(prestamo.periodicidad){
        case 0:
            periodicidad_label = 'Semanal';
          break;
        case 1:
            periodicidad_label = 'Quincenal';
          break;
        case 2:
            periodicidad_label = 'Mensual';
          break;
      }
      this.credito.prestamo.periodicidad_label = periodicidad_label;
    }

    private setCreditoDistribucion(creditoDist){
      this.creditoDistribucion = creditoDist;
      var porcentajeCapital = (creditoDist.precio_compra / creditoDist.precio_venta) * 100;
      this.creditoDistribucion.porcentajeCapital = porcentajeCapital;
      this.creditoDistribucion.porcentajeInteres = (100 - porcentajeCapital);
    }

}



// WEBPACK FOOTER //
// ./src/app/creditos/components/header-amortizacion/header-amortizacion.component.ts